import { fetch, fetchPost, uploadFile, importUploadFile } from "./api";
import types from "../mutation-types";
import paths from "../paths";
import router from "../../router/index.js";
import { enumDevice } from "@/assets/js/mToken.js";
// import { Loading } from "element-plus";
import JSEncrypt from "jsencrypt";
import storage from "@/utils/IDC/storage";
import { checkLogin } from "@/api/http";
import store from "../index";

const getEncrypt = (data) => {
  let publickKey =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMKvDoYmZuEUIX5iG6b2b1GuJUYaqAMGm+NGGlTO59KP9ccqbW6KOSu0Cp3sewbXQnzIg5QxlKzySPH9p/SlnQIAT3eMhPRAj4iP6QZ8ZH6WzVquNTNZSHomQ03Pt/Ffx1AogBQVMgdMHFTN18L6kud3NSXGqqGx1ds+q5rrVYSwIDAQAB";
  let crypt = new JSEncrypt();
  crypt.setPublicKey(publickKey);
  let ret = crypt.encrypt(data);
  return ret;
};

let timer;
// const LoadingService = Loading.service;

export const alertToggle = ({ commit }, options = null) => {
  commit(types.alertToggle, options);
};
//带参数登录
export const autoLogin = ({ commit, dispatch }, query) => {
  let url = `/login/single?area=dgkx?TICKET=${query}`;
  return fetch(url)
    .then((res) => {
      if (res.status === 1) {
        //获取权限
        let perms = [];
        fetchData(
          { commit, dispatch },
          { url: paths["ROLE.GET_ALL_PERMISSIONS"], method: "get" }
        )
          .then((response) => {
            fetchData(
              { commit, dispatch },
              { url: paths["ROLE.GET_MENU"], method: "get" }
            )
              .then((result) => {
                commit(types.loginSuccess, {
                  user: res.body.data,
                  perms: response.data,
                  menu: result.data,
                });
                checkLogin()
                  .then((res) => {
                    if (res && res.data) {
                      let info = res.data;
                      info.isLogin = true;
                      if (info.isLogin) {
                        storage.set("backupState", false);
                        store.commit("backupState", false);
                        storage.set("user", info.user);
                        storage.set("curProvinceCode", info.provinceCode);
                        storage.set("curProvinceArea", info.province);
                        storage.set("curProvince", info.provinceName);
                        storage.set("curCityCode", info.cityCode);
                        storage.set("curCityArea", info.city);
                        storage.set("curCity", info.cityName);
                        storage.set("profiles", info.profiles);
                        store.commit("SET_USER", info.user);
                        storage.set("systemName", info.systemName);
                        store.commit("SET_TITLE", info.systemName);
                        storage.set("logo", info.systemLogo);
                        store.commit("SET_LOGO", info.systemLogo);
                      } else {
                        // window.location.href = 'login.html'
                      }
                    } else {
                      // window.location.href = 'login.html'
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                commit(types.loginFailure, {
                  msg: "获取菜单失败，请联系管理员",
                });
              });
          })
          .catch((err) => {
            commit(types.loginFailure, { msg: "获取权限失败，请联系管理员" });
          });
      } else {
        if (res.msg === "已登录!") {
          if (
            router.history.pending &&
            router.history.pending.fullPath.indexOf("/login/single") > -1
          ) {
            router.push("/");
            return;
          }
        }
        commit(types.loginFailure, { msg: res.msg });
      }
    })
    .catch((error) => {
      commit(types.loginFailure, { msg: "连接失败" });
    });
};

export const psaok = ({ commit, dispatch, state }, flag = false) => {
  let deviceList = enumDevice();
  commit(types.setDeviceList, deviceList);
  let login =
    state.login.status === "success" || JSON.parse(localStorage.login);
  let user = JSON.parse(localStorage.user);
  let isManager =
    user.loginName === "sys" ||
    user.loginName === "admin" ||
    user.loginName === "rzx";
  if (login && isManager) {
    return;
  }
  if (!state.isKeyLogin) {
    return;
  }
  if (deviceList === null) {
    if (login) {
      dispatch("logout");
    }
  }
  if (deviceList.length) {
  } else {
    if (login) {
      dispatch("logout");
    }
  }
  if (!flag) {
    return;
  }
  timer = setTimeout(() => {
    dispatch("psaok", flag);
  }, 10000);
};

//警务室日志
export const loadRecordLog = ({ commit }, options = null) => {
  commit(types.recordLog, options);
};

//登录
export const login = ({ commit, dispatch }, options = null) => {
  let url = paths['USER.POST_LOGIN_BY_PASSWORD'];
  let params = {
    loginName: options.loginName,
    password: getEncrypt(options.password),
    code: options.code,
    verificationCode: options.verificationCode,
    type: options.type,
  };

  if (options.ukeyId) {
    params.ukeyId = options.ukeyId;
  }
  if (options.ukParams) {
    params = {
      ukParams: options.ukParams,
    };
  }
  return fetchPost(url, params)
    .then((res) => {
      if (res.status === 1) {
        //获取权限
        let perms = [];
        fetchData(
          { commit, dispatch },
          { url: paths["ROLE.GET_ALL_PERMISSIONS"], method: "get" }
        )
          .then((response) => {
            fetchData(
              { commit, dispatch },
              { url: paths["ROLE.GET_MENU"], method: "get" }
            )
              .then((result) => {
                commit(types.loginSuccess, {
                  user: res.body.data,
                  perms: response.data,
                  menu: result.data,
                });
              })
              .catch((err) => {
                commit(types.loginFailure, {
                  msg: "获取菜单失败，请联系管理员",
                });
              });
          })
          .catch((err) => {
            commit(types.loginFailure, { msg: "获取权限失败，请联系管理员" });
          });
      } else {
        commit(types.loginFailure, { msg: res.msg });
      }
    })
    .catch((error) => {
      commit(types.loginFailure, { msg: "连接失败" });
    });
};

//登出
export const logout = ({ commit, dispatch }, options = null) => {
  // let url = "/login/loginOut";
  let url = paths["USER.POST_LOGOUT"];
  return fetchPost(url, {})
    .then((res) => {
      res = res || {}
      res = res.data || {}
      if (res.success) {
        commit(types.logoutSuccess);
        clearTimeout(timer);
      } else {
        commit(types.logoutFailure, { msg: res.msg });
      }
    })
    .catch((error) => {
      commit(types.logoutFailure, { msg: "连接失败" });
    });
};
export const receiveSuccess = ({ commit }, { res, flag = false }) => {
  if (res.status === 1) {
    if (flag) {
      return Promise.resolve(res);
    } else {
      return Promise.resolve(res.body || res.data);
    }
  } else if (res.status === 0 || res.status === 9) {
    commit(types.loginFailure, { msg: res.msg });
    return Promise.reject(res.msg);
  } else {
    //return Promise.reject(res.msg);
    //status为2等时这里不抛出异常，否则调用的地方都要在catch才能知道真正的错误信息
    if (flag) {
      return Promise.resolve(res);
    } else {
      return Promise.resolve(res.body || res.data);
    }
  }
};

//请求数据
export const fetchData = (
  { commit, dispatch },
  { url, method, params, headers, timeout = 0, isLoading = false, flag = false, isGetParamsDirect = false }
) => {
  let path = url in paths ? paths[url] : url;
  let loading;

  if (method === "post") {
    if (isGetParamsDirect) {
      path = path + '?' + params
      params = {}
    }
    return fetchPost(path, params, headers)
      .then((res) => {
        loading && loading.close();
        return receiveSuccess({ commit, dispatch }, { res, flag });
      })
      .catch((error) => {
        loading && loading.close();
        return Promise.reject(error);
      });
  } else {
    let query = "";
    if (isGetParamsDirect) {
      query = params
    } else if (params) {
      query = Object.keys(params)
        .map(function (key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
    let fullUrl = path + "?" + query;

    return fetch(fullUrl, timeout)
      .then((res) => {
        loading && loading();
        return receiveSuccess({ commit, dispatch }, { res, flag });
      })
      .catch((error) => {
        loading && loading();
        return Promise.reject(error);
      });
  }
};
export const upload = ({ commit, dispatch }, { url, params, postParams, flag }) => {
  let path = url in paths ? paths[url] : url;
  return uploadFile(path, params, postParams, flag)
    .then((res) => {
      return receiveSuccess({ commit, dispatch }, { res });
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
//导入表格 //flag:是否需要返回res而不是res.data
export const importUpload = (
  { commit, dispatch },
  { url, params, postParams, flag = false }
) => {
  let path = url in paths ? paths[url] : url;
  return importUploadFile(path, params, postParams)
    .then((res) => {
      return receiveSuccess({ commit, dispatch }, { res, flag });
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

//获取基础字典
export const getBasicDic = ({ commit }, options) => {
  commit(types.basicDic, options);
};

export const open = ({ commit, getters, dispatch }, location) => {
  let resolved = router.resolve(location);
  if (resolved.route && resolved.route.meta && resolved.route.meta.perm) {
    let menuPerms = getters.getPermObj;
    if (menuPerms[resolved.route.meta.perm]) {
      window.open(resolved.href, "_blank");
    } else {
      dispatch("alertToggle", {
        alertType: "danger",
        alertContent: `您无权限访问${
          resolved.route.name || ""
        }，请联系管理员修改权限！`,
      });
    }
  } else if (!(resolved.route && resolved.route.name)) {
    dispatch("alertToggle", {
      alertType: "danger",
      alertContent: `您无权限访问相关功能界面，请联系管理员修改权限！`,
    });
  } else if (resolved.href) {
    window.open(resolved.href, "_blank");
  }
};

export const openSelf = ({ commit, getters, dispatch }, location) => {
  let resolved = router.resolve(location);
  if (resolved.route && resolved.route.meta && resolved.route.meta.perm) {
    let menuPerms = getters.getPermObj;
    if (menuPerms[resolved.route.meta.perm]) {
      window.open(resolved.href, "_self");
      /* router.push(location)*/
    } else {
      dispatch("alertToggle", {
        alertType: "danger",
        alertContent: `您无权限访问${
          resolved.route.name || ""
        }，请联系管理员修改权限！`,
      });
    }
  } else if (!(resolved.route && resolved.route.name)) {
    dispatch("alertToggle", {
      alertType: "danger",
      alertContent: `您无权限访问相关功能界面，请联系管理员修改权限！`,
    });
  } else if (resolved.href) {
    window.open(resolved.href, "_self");
    /* router.push(location)*/
  }
};
